import React from "react";

const MusicVideos = () => {
  return <div>MusicVideos</div>;
};

export default MusicVideos;
